import catalog from "../../../app/dashboard_report_catalog.json" with { type: "json" };

export const DASHBOARD_REPORT_CATALOG = catalog;
export const DASHBOARD_REPORT_BY_KEY = Object.fromEntries(catalog.map((entry) => [entry.key, entry]));
export const DASHBOARD_REPORT_LABELS = Object.fromEntries(catalog.map((entry) => [entry.key, entry.label]));
